import { render, staticRenderFns } from "./PerfilFormModal.vue?vue&type=template&id=932af970&scoped=true"
import script from "./PerfilFormModal.vue?vue&type=script&lang=js"
export * from "./PerfilFormModal.vue?vue&type=script&lang=js"
import style0 from "./PerfilFormModal.vue?vue&type=style&index=0&id=932af970&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "932af970",
  null
  
)

export default component.exports